export default __webpack_public_path__ + "static/media/header_main.5ddd664f.svg";